import Session from 'store2';
import { CRYPTO_SECRET } from './ApiConfig';
import { BASE_URL } from '../config';
var CryptoJS = require("crypto-js");


class ApiHelper {

    static headers() {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    }

    static GetToken() {
        return Session.session('token');
    }

    static GetSessionToken() {
        return Session.session('session_token');
    }

    static getAnonymous(route, abortController) {
        return this.xhr(route, null, null, null, 'GET', abortController);
    }

    static getAuthenticated(route, params, abortController) {
        return this.xhr(route, params, ApiHelper.GetToken(), null, 'GET', abortController);
    }
    static getAuthenticatedData(route, params, abortController) {
        return this.xhr(route, params, null, null, 'GET', abortController);
    }

    static putAnonymous(route, params, abortController) {
        return this.xhr(route, params, null, null, 'PUT', abortController);
    }

    static putAuthenticated(route, params, abortController) {
        return this.xhr(route, params, ApiHelper.GetToken(), null, 'PUT', abortController);
    }

    static patchAnonymous(route, params, abortController) {
        return this.xhr(route, params, null, null, 'PATCH', abortController);
    }

    static patchAuthenticated(route, params, abortController) {
        return this.xhr(route, params, ApiHelper.GetToken(), null, 'PATCH', abortController);
    }

    static postAuthenticated(route, params, abortController) {
        return this.xhr(route, params, ApiHelper.GetToken(), null, 'POST', abortController);
    }

    static postAuthenticatedImage(route, params, abortController) {
        return this.xhrImage(route, params, ApiHelper.GetToken(), null, 'POST', abortController);
    }

    static postAuthenticatedDownload(route, params, abortController) {
        return this.xhrDownloadFile(route, params, ApiHelper.GetToken(), 'POST', abortController);
    }

    static postAnonymous(route, params, abortController) {
        return this.xhr(route, params, null, null, 'POST', abortController);
    }
    static postAnonymousCheckVPN(route, params, abortController) {
        return this.xhr(route, params, null, null, 'GET', abortController);
    }

    static postAnonymousOTP(route, params, abortController) {
        return this.xhr(route, params, null, ApiHelper.GetSessionToken(), 'POST', abortController);
    }

    static deleteAnonymous(route, params, abortController) {
        return this.xhr(route, params, null, null, 'DELETE', abortController);
    }

    static deleteAuthenticated(route, params, abortController) {
        return this.xhr(route, params, ApiHelper.GetToken(), null, 'DELETE', abortController);
    }

    static async xhr(route, params, token = "", session_token = "", verb, abortController) {

        var newbody = "";
        if (params) {
            var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(params), CRYPTO_SECRET).toString();
            let result = ciphertext.toString().replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l');
            newbody = JSON.stringify({ "body_encrypted": result });
        }

        const host = BASE_URL;
        const url = host + route;
        let options = Object.assign({ method: verb }, params ? { body: newbody } : null);
        if (abortController && abortController.signal) {
            options.signal = abortController.signal;
        }
        options.headers = ApiHelper.headers();
        if (token) {
            options.headers = {
                ...options.headers,
                'Authorization': 'Bearer ' + token
            }
        }
        if (session_token) {
            options.headers = {
                ...options.headers,
                'sessiontoken': session_token
            }
        }

        return fetch(url, options).then(resp => {
            if (resp.status === 401) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }
            if (resp.status === 500) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }
            if (resp.status === 422) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }
            if (resp.status === 403) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }


            let json = resp.json();
            if (resp.ok) {
                return json;
            }
            return json.then(err => { throw err });
        });
    }

    static async xhrImage(route, params, token = "", session_token = "", verb, abortController) {

        const host = BASE_URL;
        const url = host + route;
        let options = { method: verb };

        if (abortController && abortController.signal) {
            options.signal = abortController.signal;
        }
        options.headers = {};
        if (token) {
            options.headers = {
                ...options.headers,
                'Authorization': 'Bearer ' + token
            }
        }

        options.body = params;

        return fetch(url, options).then(resp => {
            if (resp.status === 401) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }
            if (resp.status === 500) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }
            if (resp.status === 422) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }
            if (resp.status === 403) {
                return resp.text().then(text => {
                    return text && JSON.parse(text);
                });
            }


            let json = resp.json();
            if (resp.ok) {
                return json;
            }
            return json.then(err => { throw err });
        });
    }

    static async xhrDownloadFile(route, params, token = "", verb, abortController) {
        const host = BASE_URL;
        const url = host + route;

        let options = {
            method: verb,
            headers: ApiHelper.headers()
        };

        if (params) {
            options.body = JSON.stringify(params); // Assuming params is a body string or FormData
        }

        if (abortController && abortController.signal) {
            options.signal = abortController.signal;
        }

        if (token) {
            options.headers['Authorization'] = 'Bearer ' + token;
        }

        try {
            const response = await fetch(url, options);

            // Handle non-blob responses
            if (!response.ok) {
                const errorText = await response.text();
                let error;
                try {
                    error = JSON.parse(errorText);
                } catch {
                    error = errorText;
                }
                throw new Error(error);
            }

            // Return blob for successful responses
            return response.blob();

        } catch (error) {
            console.error('Error downloading file:', error);
            throw error;
        }
    }

}

export default ApiHelper;